import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import("../views/login"),
            meta: {
                title: '登录'
            }
        },
        {
            path: '/index',
            name: 'index',
            component: () => import("../views/index"),
            meta: {
                title: '体检服务',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/personal',
            name: 'personal',
            component: () => import("../views/personal"),
            meta: {
                title: '个人中心',
                requireAuth: true,
                id: 2
            }
        },
        {
            path: '/subscribe',
            name: 'subscribe',
            component: () => import("../views/subscribe"),
            meta: {
                title: '预约体检',
                requireAuth: true,
                isBack: false,
                keepAlive: true,
                id: 1
            }
        }, 
        {
            path: '/confirm',
            name: 'confirm',
            component: () => import("../views/confirm"),
            meta: {
                title: '订单确认',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/report',
            name: 'report',
            component: () => import("../views/report"),
            meta: {
                title: '体检报告',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/reportImg',
            name: 'reportImg',
            component: () => import("../views/reportImg"),
            meta: {
                title: '体检报告详情',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/healthInformation',
            name: 'healthInformation',
            component: () => import("../views/healthInformation/healthInformation.vue"),
            meta: {
                title: '健康咨询',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/suggestion',
            name: 'suggestion',
            component: () => import("../views/suggestion"),
            meta: {
                title: '投诉建议',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/reimburse',
            name: 'reimburse',
            component: () => import("../views/reimburse"),
            meta: {
                title: '在线报销',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/billConfirm',
            name: 'billConfirm',
            component: () => import("../views/billConfirm"),
            meta: {
                title: '在线报销-信息确认',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/reimburseSuccess',
            name: 'reimburseSuccess',
            component: () => import("../views/reimburseSuccess"),
            meta: {
                title: '在线报销-申请提交成功',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/exportFile',
            name: 'exportFile',
            component: () => import("../views/exportFile"),
            meta: {
                title: '在线报销-导出报销单',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/dispatchList',
            name: 'dispatchList',
            component: () => import("../views/dispatchList"),
            meta: {
                title: '报销单列表',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/dispatchDetail',
            name: 'dispatchDetail',
            component: () => import("../views/dispatchDetail"),
            meta: {
                title: '报销单详情',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/declarationInformation',
            name: 'declarationInformation',
            component: () => import("../views/declarationInformation"),
            meta: {
                title: '填写申报信息',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/order',
            name: 'order',
            component: () => import("../views/order"),
            meta: {
                title: '体检订单',
                requireAuth: true,
                id: 2,
                isBack: false,
                keepAlive: true,
            }
        },
        {
            path: '/orderDetail',
            name: 'orderDetail',
            component: () => import("../views/orderDetail"),
            meta: {
                title: '体检订单详情',
                requireAuth: true,
                id: 2
            }
        },
        {
            path: '/survey',
            name: 'survey',
            component: () => import("../views/survey"),
            meta: {
                title: '满意度调查',
                requireAuth: true,
                id: 2
            }
        },
        {
            path: '/success',
            name: 'success',
            component: () => import("../views/success"),
            meta: {
                title: '预约成功',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/error',
            name: 'error',
            component: () => import("../views/error"),
            meta: {
                title: '预约失败',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/middlePage',
            name: 'middlePage',
            component: () => import("../views/middlePage"),
            meta: {
                title: '预约中',
                requireAuth: true,
                id: 1
            }
        },
        {
            path: '/pdf',
            name: 'Pdf',
            component: () => import("@/components/pdf/pdf"),
            meta: {
                title:'pdf'
            }
        }

    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js